import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SvgSymbol extends Component {
  static defaultProps = {
    includeViewBox: false
  }

  componentDidMount(){
    if (this.props.name){
      return import(`./svgs/${this.props.name}.svg`).default
    }
  }

  componentDidUpdate(prevProps){
    if (this.props.name && prevProps.name !== this.props.name) {
      return import(`./svgs/${this.props.name}.svg`).default
    }
  }

  render() {
    let el = null;

      const defaultSvg = (
        <svg className={this.props.parentClassName} viewBox={null}>
          <use xlinkHref={`#${this.props.name}`} />
        </svg>
      )
      
      if(this.props.title) {
        el = (
          <div title={this.props.title} style={{display:'inline', lineHeight: 0}}>  
            {defaultSvg}
          </div>
        )
      }
      else {
        el = defaultSvg
      }
      
    return el;
  }
}

SvgSymbol.propTypes = {
  /* The name should match the file name of svg (without.svg) */
  name: PropTypes.string.isRequired,
  parentClassName: PropTypes.string,
  includeViewBox: PropTypes.bool,
  title: PropTypes.string
};

export default SvgSymbol;



// WEBPACK FOOTER //
// ./src/components/SvgSymbol/SvgSymbol.jsx